import {
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/components/ui/form";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function MetricSelect({ form }: { form: any }) {
    return (
        <FormField
            control={form.control}
            name="metric"
            render={({ field }) => (
                <FormItem>
                    <div className="flex items-center gap-2">
                        <FormLabel>Goal</FormLabel>

                        {/* <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <HelpCircle className="h-4 w-4 text-muted-foreground" />
                                </TooltipTrigger>
                                <TooltipContent className="max-w-[300px]">
                                    <p>
                                        <b>Gross profit:</b> Total revenue minus
                                        costs over a period of time. Use this
                                        metric if prices are shown in adverts
                                        where pricing may influence the number
                                        of website visitors.
                                    </p>
                                    <p>
                                        <b>Profit per visitor:</b> Average
                                        profit per website visitor. Use this
                                        metric if you prices are not shown in
                                        adverts and won't affect the number of
                                        website visitors.
                                    </p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider> */}
                    </div>
                    <FormDescription>
                        What is the target outcome of this optimization?
                    </FormDescription>
                    <div className="grid grid-cols-3 gap-4">
                        <Card
                            className={cn(
                                "p-4 cursor-pointer transition-all hover:border-primary",
                                field.value === "ppv" &&
                                    "border-primary bg-primary/5"
                            )}
                            onClick={() => field.onChange("ppv")}
                        >
                            <h3 className="font-medium">
                                Maximize gross profit
                            </h3>
                            <p className="text-sm text-muted-foreground mt-1">
                                Find the price that maximizes gross profit
                            </p>
                        </Card>
                        <Card
                            className={cn(
                                "p-4 cursor-not-allowed opacity-50",
                                field.value === "sales-profitable" &&
                                    "border-primary bg-primary/5"
                            )}
                        >
                            <h3 className="font-medium">
                                Clear inventory (profitable)
                            </h3>
                            <p className="text-sm text-muted-foreground mt-1">
                                Find the price that maximizes sales to clear
                                inventory while maintaining profit margin
                            </p>
                            <p className="text-xs text-muted-foreground mt-2">
                                Coming soon
                            </p>
                        </Card>
                        <Card
                            className={cn(
                                "p-4 cursor-not-allowed opacity-50",
                                field.value === "sales-losses" &&
                                    "border-primary bg-primary/5"
                            )}
                        >
                            <h3 className="font-medium">
                                Clear inventory (minimize losses)
                            </h3>
                            <p className="text-sm text-muted-foreground mt-1">
                                Find the price that maximizes sales to clear
                                inventory while minimizing losses
                            </p>
                            <p className="text-xs text-muted-foreground mt-2">
                                Coming soon
                            </p>
                        </Card>
                    </div>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
